(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('documo', {
                parent: 'entity',
                url: '/documo',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'Documos'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/documo/list/documo.html',
                        controller: 'DocumoController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();
